import { Container, Typography } from "@mui/material";
import * as React from "react";

export const FourOhFourPage: React.FC = function () {
  return (
    <Container>
      <Typography variant="h2" sx={{ p: 2 }}>
        404 Not Found
      </Typography>
    </Container>
  );
};
